export default "__VITE_ASSET__BTpDOyUW__"